import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { format } from 'date-fns'

import determineImageCrop from './lib/image-crop-determiner'
import changeFileExtension from '@/lib/filename-extension-modifier'
import Card from '@/component/Primitive/Card'
import CarouselComponent from '@/component/Primitive/Carousel'

import brandToColor from '@/lib/brand-to-color'
import { ThemeContext } from '@/component/Context/ThemeContext'
import CardButton from '@/component/Primitive/Card/component/CardButton'

const Carousel = ({ articles, itemsPerRow }) => {
  const { theme } = useContext(ThemeContext)

  const formattedArticles = articles.results?.map((article) => {
    const imageCrop = determineImageCrop(article.contentType)

    const imageSizeMap = {
      landscape: [138, 206, 290, 412, 580, 900],
      portrait: [104, 208, 290, 580, 720, 900],
      widescreen: [322, 553, 644, 1106]
    }

    return {
      id: article._id,
      title: article.headline,
      subtitle:
        article.contentType === 'Event'
          ? `${format(
              new Date(article.startDate),
              'EE dd MMM, yyyy'
            )} • ${format(new Date(article.startDate), 'HH:mm')} • ${
              article.address
            }`
          : null,
      link: article.fullUrlPath,
      contentType: article.contentType,
      description: article.contentType === 'Event' ? article.sell : null,
      src: article.images?.thumbnail_landscape_290?.[0]?.url,
      srcSet: imageSizeMap[imageCrop].map((size) => {
        return {
          width: size,
          src: changeFileExtension(
            article.images?.[`thumbnail_${imageCrop}_${size}`]?.[0]?.url,
            'webp'
          )
        }
      })
    }
  })

  const getFooterComponents = (type) => {
    const typeMap = {
      Event: () => <CardButton>Register now</CardButton>
    }
    return typeMap[type] || null
  }

  const getImageIcon = (type) => {
    const typeMap = {
      Video: 'play'
    }
    return typeMap[type] || null
  }

  return (
    <CarouselComponent itemsPerRow={itemsPerRow}>
      {formattedArticles?.map((article, i) => (
        <div
          key={`CarouselComponent--Article--${i}`}
          style={{
            width: `calc(${100 / itemsPerRow}% - ${
              ((itemsPerRow - 1) * 24) / itemsPerRow
            }px)`
          }}
        >
          <Card
            link={article.link}
            title={article.title}
            src={article.src}
            subtitle={article.subtitle}
            typeConfig={{
              title: { themed: true },
              subtitle: {
                color: brandToColor(theme)
              }
            }}
            footerComponents={getFooterComponents(article.contentType) || null}
            description={article.description}
            imageRatio={9 / 16}
            imageIcon={getImageIcon(article.contentType)}
            srcSet={article.srcSet}
            sizes={[
              '(min-width: 1420px) 330px',
              '(min-width: 960px) calc(25vw - 32px - 80px)',
              'calc(75vw - 80px)'
            ]}
            width={330}
            shouldShowSubtitle={article.contentType === 'Event'}
            truncateTitleAt={article.contentType === 'Video' ? 2 : undefined}
          />
        </div>
      ))}
    </CarouselComponent>
  )
}

Carousel.propTypes = {
  articles: PropTypes.object,
  itemsPerRow: PropTypes.number
}

export default Carousel
